<form
  [formGroup]="buyerDetailsForm"
  (ngSubmit)="onSubmit()"
  class="buyer-details-form"
  novalidate
>
  <div class="grid nested-grid">
    <!-- First Section: Four fields on the left side -->
    <div class="col-6">
      <div class="grid">
        <!-- Buyer Legal Name -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="p-field">
            <label for="buyerLegalName" class="required"
              >Buyer Legal Name</label
            ><i
            class="pi pi-info-circle tooltip-icon"
            pTooltip="Please enter the Buyer legal name using only characters from the Latin alphabet (A-Z, a-z), digits (0-9), and symbols. Foreign characters are not supported."
            tooltipPosition="right"
          ></i>
            <input
              id="buyerLegalName"
              formControlName="buyerLegalName"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['buyerLegalName'].touched && f['buyerLegalName'].invalid) {
              <div class="p-error">
                @if (f['buyerLegalName'].errors?.['required']) {
                  <span>Buyer Legal Name is required</span>
                }
                @if (f['buyerLegalName'].errors?.['invalidValue'] || f['buyerLegalName'].errors?.['maxLengthExceeded']) {
                  <span>
                    Please provide a valid Buyer legal name (max 300 characters) using only characters from the Latin alphabet
                    (A-Z, a-z), digits (0-9), and symbols. Foreign characters are not supported.
                  </span>
                }
              </div>
            }
          </div>
        </div>

        <!-- SST Registration Number -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="p-field">
            <label for="sstRegNumber" class="required"
              >SST Registration Number
            </label>
            <i
              class="pi pi-info-circle tooltip-icon"
              pTooltip="Example: A01-2345-67891012. Please input 'NA' if not applicable"
              tooltipPosition="right"
            ></i>
            <input
              id="sstRegNumber"
              formControlName="sstRegNumber"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['sstRegNumber'].touched && f['sstRegNumber'].invalid) {
              <div class="p-error">
                @if (f['sstRegNumber'].errors?.['required']) {
                  <span>SST Registration Number is required</span>
                }
                @if (f['sstRegNumber'].errors?.['invalidCharacters'] || f['sstRegNumber'].errors?.['maxLengthExceeded']) {
                  <span>
                    Please provide valid SST Registration Number (max 35 characters
                    for a maximum of two SST Registration Number, separated by a
                    semicolon)
                  </span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Contact Number -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="p-field">
            <label for="contactNumber" class="required">Contact Number</label>
            <i
              class="pi pi-info-circle tooltip-icon"
              pTooltip="Please enter the contact number in this format: [+][country code][subscriber number, including area code]. For example: +60123456789."
              tooltipPosition="right"
            ></i>
            <input
              id="contactNumber"
              formControlName="contactNumber"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['contactNumber'].touched && f['contactNumber'].invalid) {
              <div class="p-error">
                @if (f['contactNumber'].errors?.['required']) {
                  <span>Contact Number is required</span>
                }
                @if (f['contactNumber'].errors?.['invalidCharacters'] || f['contactNumber'].errors?.['maxLengthExceeded'] || f['contactNumber'].errors?.['minLength']) {
                  <span>
                    Please provide a valid Contact Number (Min 8 characters and max 20 characters) starting with a plus sign (+) followed by only numbers (0-9).
                  </span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Email Address -->
        <div class="col-12 md:col-6 lg:col-6">
          <div class="p-field">
            <label for="email" class="required">Email Address</label>
            <i
              class="pi pi-info-circle tooltip-icon"
              pTooltip="Example: general.ams@supplier.com"
              tooltipPosition="right"
            ></i>
            
            <div class="p-input-icon-right">
              @if (isEmailValidated && isOtpConfirmed) {
                <span class="validation-icon">
                  <i class="pi pi-check"></i>
                </span>
              }
              <input
                id="email"
                formControlName="email"
                pInputText
                [disabled]="isEmailValidated && isOtpConfirmed"
              />
            </div>
            @if (f['email'].touched && f['email'].invalid) {
              <div class="p-error">
              <!-- Show validation messages -->
                @if (f['email'].errors?.['required']) {
                  <span>Email Address is required</span>
                }
                @if (f['email'].errors?.['invalidEmail']) {
                  <span>Provide proper email ID (max 320 characters)</span>
                }
                @if (f['email'].errors?.['maxLengthExceeded']) {
                  <span>Provide proper email ID (max 320 characters)</span>
                }
                @if (f['email'].errors?.['invalidSpace']) {
                  <span>Provide proper email ID (max 320 characters)</span>
                }
              </div>
            }
          </div>
        
          @if (!isEmailValidated && !isOtpConfirmed) {
            <button
            type="button"
            class="ey-button-dark mt-3"
            [disabled]="f['email'].invalid || isEmailValidated"
            (click)="onValidateEmail()"
            [pTooltip]="f['email'].invalid || isEmailValidated ? '' : 'Click here to validate the email address by OTP.'"
            tooltipPosition="right"
            >Validate</button>
          }
          @if (isOtpConfirmed) {
            <button
            type="button"
            class="ey-button-dark mt-3"
            (click)="onResetEmail()"
            pTooltip="Click here to reset the validated email address."
            tooltipPosition="right"
            >Reset Email</button>
          }

          @if (isOtpRequested && !isOtpConfirmed) {
            <div class="mt-2">
            <!-- Row 1: Enter OTP (60%) and Timer + Resend OTP (40%) -->
            <div class="p-field otp-entry-row">
              <!-- Enter OTP field (60%) -->
              <div class="otp-entry-field">
                <label for="otp">Enter OTP</label>
                <input
                  id="otp"
                  formControlName="otp"
                  pInputText
                  [disabled]="isOtpConfirmed"
                  (keypress)="allowOnlyNumbers($event)"
                  (input)="removeNonNumeric($event)"
                />
              </div>
          
              <!-- Timer and Resend OTP (40%) stacked vertically -->
              <div class="otp-entry-actions">
                <span  [class.disabled]="otpTimer===0" class="otp-timer">{{ otpTimer }} Sec</span>
                <a
                  class="resend-otp-link"
                  [class.disabled]="isResendDisabled"
                  (click)="!isResendDisabled && onResendOtp()"
                >
                  Resend OTP
                </a>
              </div>
            </div>
          
            <!-- Row 2: Confirm Button -->
            <button
              type="button"
              class="ey-button-dark mt-3"
              [disabled]="f['otp'].invalid || isOtpConfirmed"
              (click)="onConfirmOtp()"
              [pTooltip]="f['otp'].invalid || isOtpConfirmed ? '' : 'Click here to confirm the OTP.'"
              tooltipPosition="right"
            >Confirm</button>
            </div>
          }
          
          
          
        </div>
        
     
        
      
        
      </div>
    </div>

    <!-- Second Section: Seven fields on the right side with left border -->
    <div class="col-6 border-left">
      <div class="grid">
        <!-- Address Line 1 -->
        <div class="col-12">
          <div class="p-field">
            <label for="addressLine1" class="required">Address Line 1</label>
            <input
              id="addressLine1"
              formControlName="addressLine1"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['addressLine1'].touched && f['addressLine1'].invalid) {
              <div class="p-error">
                @if (f['addressLine1'].errors?.['required']) {
                  <span>Address Line 1 is required</span>
                }
                @if (f['addressLine1'].errors?.['maxLengthExceeded']) {
                  <span>Please provide valid address line 1 (max 150 characters)</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Address Line 2 -->
        <div class="col-6">
          <div class="p-field">
            <label for="addressLine2">Address Line 2</label>
            <input
              id="addressLine2"
              formControlName="addressLine2"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['addressLine2'].touched && f['addressLine2'].invalid) {
              <div class="p-error">
                @if (f['addressLine2'].errors?.['maxLengthExceeded']) {
                  <span>Please provide valid address line 2 (max 150 characters)</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Address Line 3 -->
        <div class="col-6">
          <div class="p-field">
            <label for="addressLine3">Address Line 3</label>
            <input
              id="addressLine3"
              formControlName="addressLine3"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['addressLine3'].touched && f['addressLine3'].invalid) {
              <div class="p-error">
                @if (f['addressLine3'].errors?.['maxLengthExceeded']) {
                  <span>Please provide valid address line 3 (max 150 characters)</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- Post Code -->
        <div class="col-6">
          <div class="p-field">
            <label for="postCode">Post Code</label>
            <input
              id="postCode"
              formControlName="postCode"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['postCode'].touched && f['postCode'].invalid) {
              <div class="p-error">
                @if (f['postCode'].errors?.['maxLengthExceeded']) {
                  <span>Please provide valid Address Post Code (max 50 characters)</span>
                }
                @if (f['postCode'].errors?.['invalidPostCodeMalaysia']) {
                  <span>Please provide a valid Address Post code (Max 5 numeric characters (0-9)).</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- City -->
        <div class="col-6">
          <div class="p-field">
            <label for="city" class="required">City</label>
            <input
              id="city"
              formControlName="city"
              pInputText
              [disabled]="isFormSubmitted"
            />
            @if (f['city'].touched && f['city'].invalid) {
              <div class="p-error">
                @if (f['city'].errors?.['required']) {
                  <span>Address City is required</span>
                }
                @if (f['city'].errors?.['maxLengthExceeded']) {
                  <span>Please provide valid Address City (max 50 characters)</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- State Dropdown -->
        <div class="col-6">
          <div class="p-field">
            <label for="state" class="required">State</label>
            <p-select
              id="state"
              formControlName="state"
              [options]="stateOptions"
              optionLabel="name"
              optionValue="value"
              [disabled]="isFormSubmitted"
              [filter]="true"
              filterPlaceholder="Search state"
              [class.is-invalid]="f['state'].touched && f['state'].invalid"
            ></p-select>
            @if (f['state'].touched && f['state'].invalid) {
              <div class="p-error">State is required</div>
            }
          </div>
        </div>

        <!-- Country Dropdown -->
        <div class="col-6">
          <div class="p-field">
            <label for="country" class="required">Country</label>
            <p-select
              id="country"
              formControlName="country"
              [options]="countryOptions"
              optionLabel="name"
              optionValue="value"
              [disabled]="isFormSubmitted"
              [filter]="true"
              filterPlaceholder="Search country"
              [class.is-invalid]="f['country'].touched && f['country'].invalid"
            ></p-select>
            @if (f['country'].touched && f['country'].invalid) {
              <div class="p-error">Country is required</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  @if (!isFormSubmitted) {
    <div class="col-12 p-field">
      <div class="button-container align-right">
        <button
          type="submit"
          class="ey-button-dark mt-0"
          [disabled]="buyerDetailsForm.invalid"
          [pTooltip]="buyerDetailsForm.invalid ? '' : 'Click to submit the B2B invoice request.'"
          tooltipPosition="right"
        >Submit</button>
      </div>
    </div>
  }
</form>
